import { render, staticRenderFns } from "./Model1.vue?vue&type=template&id=0be860f5&scoped=true"
import script from "./Model1.vue?vue&type=script&lang=js"
export * from "./Model1.vue?vue&type=script&lang=js"
import style0 from "./Model1.vue?vue&type=style&index=0&id=0be860f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be860f5",
  null
  
)

export default component.exports